import apiClient from './client';

export interface PetTip {
  id: string;
  text_zh: string;
  text_en: string;
  is_enabled: boolean;
  sort_order: number;
  category: string;
  weight: number;
}

export interface PetTipsConfig {
  enabled: boolean;
  min_interval_seconds: number;
  max_interval_seconds: number;
  visible_seconds: number;
  daily_auto_limit: number;
  dismiss_cooldown_seconds: number;
  seen_cooldown_days: number;
  tips: PetTip[];
}

export interface PetTipsSaveResponse {
  status: string;
  version: number;
}

export const petTipsApi = {
  getConfig: async (): Promise<PetTipsConfig> => {
    const response = await apiClient.get<PetTipsConfig>('/pet-tips/config');
    return response.data;
  },

  updateConfig: async (config: PetTipsConfig): Promise<PetTipsSaveResponse> => {
    const response = await apiClient.put<PetTipsSaveResponse>('/pet-tips/config', config);
    return response.data;
  },
};
